import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function FormField({
  label,
  name,
  value,
  onChange,
  placeholder,
  type = "text",
  options = null,
  showToggle = false,
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="col-md-6">
      <label className="form-label fw-semibold text-secondary">{label}</label>

      {options ? (
        <select
          name={name}
          value={value || ""}
          onChange={onChange}
          className="form-select form-select-lg rounded-pill shadow-sm fs-6"
          style={{
            boxShadow: "inset 4px 4px 8px #c9c9c9, inset -4px -4px 8px #ffffff",
          }}
        >
          <option value="">Select {label}</option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <div className="input-group">
          <motion.input
            whileFocus={{ scale: 1.02 }}
            type={showToggle && showPassword ? "text" : type}
            name={name}
            value={value || ""}
            onChange={onChange}
            placeholder={placeholder}
            className="form-control form-control-lg rounded-pill shadow-sm fs-6"
            style={{
              boxShadow:
                "inset 4px 4px 8px #c9c9c9, inset -4px -4px 8px #ffffff",
            }}
          />
          {showToggle && type === "password" && (
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="position-absolute top-50 end-0 translate-middle-y pe-3"
              style={{ cursor: "pointer" }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
